import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="relative px-6 pt-12 pb-20 md:pt-20 md:pb-32 overflow-hidden" data-id="element-1">
      <div className="max-w-2xl mx-auto text-center relative z-10" data-id="element-2">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-3">
          <span className="inline-block px-3 py-1 mb-6 text-xs tracking-widest uppercase text-[#C4956A] border border-[#C4956A]/30 rounded-full bg-[#C4956A]/5" data-id="element-4">
            Manual de Emergencia
          </span>

          <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-tight text-[#E8E0D4] mb-4" data-id="element-5">
            No es falta de amor. <br data-id="element-6" />
            <span className="text-[#C4956A] italic" data-id="element-7">Es un loop.</span>
          </h1>

          <p className="text-[#9B9285] text-lg md:text-xl mb-8 font-light" data-id="element-8">
            Y esta noche va a volver a pasar.
          </p>

          <div className="space-y-3 mb-12 text-[#9B9285] text-sm md:text-base font-light tracking-wide" data-id="element-9">
            <p data-id="element-10">Que tu mente no decida por ti esta noche.</p>
            <p data-id="element-11">7 días sin googlear "señales de que no lo amo".</p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1,
        delay: 0.2
      }} className="relative mb-16 rounded-lg overflow-hidden shadow-2xl shadow-[#C4956A]/10 border border-[#C4956A]/10" data-id="element-12">
          <div className="absolute inset-0 bg-gradient-to-t from-[#0F0E0C] via-transparent to-transparent z-10 opacity-60" data-id="element-13"></div>
          <img src="https://cdn.magicpatterns.com/uploads/fUS5VdWmH6PAHsyuqfZyfu/concepto_2.png" alt="Warm lamp on nightstand in dark room" className="w-full h-auto object-cover opacity-90 sepia-[0.2]" data-id="element-14" />
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="text-left space-y-6 text-[#E8E0D4]/90 leading-relaxed text-lg" data-id="element-15">
          <p data-id="element-16">
            Hay una hora en la que tu casa está callada…
            <br data-id="element-17" />y tu cabeza hace ruido como si estuviera en una sala de
            juicio.
          </p>

          <p data-id="element-18">No llega como una duda normal. Llega como sentencia:</p>

          <div className="pl-6 border-l-2 border-[#C4956A]/40 italic text-[#C4956A] space-y-2 py-2 my-6 font-serif text-xl" data-id="element-19">
            <p data-id="element-20">"¿Y si ya no lo amo?"</p>
            <p data-id="element-21">"¿Y si estoy fingiendo?"</p>
            <p data-id="element-22">"¿Y si estoy desperdiciando mi vida?"</p>
          </div>

          <p data-id="element-23">
            Y lo peor: se siente moral.
            <br data-id="element-24" />
            Como si fueras mala persona por no tener una respuesta perfecta.
          </p>

          <p className="font-medium text-[#E8E0D4]" data-id="element-25">
            Este PDF no va a decirte qué decidir.
            <br data-id="element-26" />
            Va a hacer algo más útil:{' '}
            <span className="text-[#C4956A]" data-id="element-27">te va a sacar del loop</span> para
            que dejes de vivir con la garganta apretada.
          </p>

          <motion.div initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.8
        }} className="pt-8 text-center" data-id="element-28">
            <p className="text-[#9B9285] text-sm mb-4 italic" data-id="element-29">
              Miles de mujeres viven esto en silencio. Tú ya diste el primer
              paso.
            </p>
            <a href="https://cuerpoencalma.it.com/cart/47443462979771:1" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-6 py-3 text-base font-medium text-[#0F0E0C] bg-[#C4956A] rounded-lg transition-all hover:bg-[#D4A574] hover:shadow-lg hover:shadow-[#C4956A]/20" data-id="element-30">
              Quiero el Kit R.O.O.F. — $6.36
              <span data-id="element-31">→</span>
            </a>
            <p className="text-[#9B9285]/60 text-xs mt-3" data-id="element-32">
              Menos que un café. Más que otra noche sin dormir.
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}